import styled from 'styled-components';

import { FlexCard } from '@ui-library/card';

export const SelectableCard = styled(FlexCard)<{ isSelected?: boolean }>`
  flex: 0 0 auto;

  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.token['blue.2'] : theme.token.colorInfoBg};
  border-color: ${({ theme, isSelected }) =>
    isSelected ? theme.token['blue.6'] : theme.token.colorBorderSecondary};
  &:hover {
    background-color: ${({ theme, isSelected }) =>
      isSelected ? theme.token['blue.2'] : theme.token['blue.1']};
    border-color: ${({ theme }) => theme.token['blue.6']};
    cursor: pointer;
  }
`;
